const numintecTest = "//test.invoxcontact.io";
const numintecStaging = "//staging.invoxcontact.io";
const numintecProd = "//go.invoxcontact.io";
const generaliTest = "//gtest.invoxcontact.io";
const generaliStaging = "//gstaging.invoxcontact.io";
const generaliProd = "//ggo.invoxcontact.io";
const generaliOldProd = "//go-generali.invoxcontact.io";

export const isGenerali = () => {
    const websiteUrl = window.location.href;
    let bool = false;

    if (websiteUrl.includes(numintecTest)) {
        bool = false;
    } else if (websiteUrl.includes(numintecStaging)) {
        bool = false;
    } else if (websiteUrl.includes(numintecProd)) {
        bool = false;
    } else if (websiteUrl.includes(generaliTest)) {
        bool = true;
    } else if (websiteUrl.includes(generaliStaging)) {
        bool = true;
    } else if (websiteUrl.includes(generaliProd)) {
        bool = true;
    } else if (websiteUrl.includes(generaliOldProd)) {
        bool = true;
    } else {
        bool = false;
    }

    return bool;
}